import { Component, computed, inject, Input, model, signal } from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-skill-list',
  templateUrl: './skill-list.component.html',
  styleUrl: './skill-list.component.scss'
})
export class SkillListComponent {
  readonly announcer = inject(LiveAnnouncer);

  @Input() selectedSkills = signal<string[]>([]);
  @Input() allSkills = signal<string[]>([]);
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly currentSkill = model('');
  readonly filteredSkills = computed(() => this.allSkills().filter(skill => this.selectedSkills().includes(skill)===false));

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (value) {
      this.selectedSkills.update(skills => [...skills, value].filter(this.uniqueFilter));
    }

    // Clear the input value
    this.currentSkill.set('');
  }

  remove(skill: string): void {
    this.selectedSkills.update(skills => {
      const index = skills.indexOf(skill);
      if (index < 0) {
        return skills;
      }

      skills.splice(index, 1);
      this.announcer.announce(`Removed ${skill}`);
      return [...skills];
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedSkills.update(skills => [...skills, event.option.viewValue]);
    this.currentSkill.set('');
    event.option.deselect();
  }

  private uniqueFilter(value: string, index: number, self: string[]) {
    return self.indexOf(value) === index;
  }
}
